<template>
    <span :class="['adv-btn', type, col]" :style="{ width: btnWidth }">
        <slot></slot>
    </span>
</template>
<script>
export default {
    name: 'AdvBtn',
    props: {
        col: {
            type: String,
            default: 'inline'
        },
        type: {
            type: String,
            default: 'primary' // primary/reverse
        },
        width: {
            type: [Number, String]
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
        btnWidth({ width, type, isMobileSize }) {
            if (width) {
                return width;
            } else {
                if (isMobileSize) {
                    return '100%';
                } else {
                    return type === 'primary' ? '147px' : '288px';
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.adv-btn {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    display: inline-block;
    cursor: pointer;
    font-family: var(--font-bold);
    &:hover {
        opacity: 0.9;
    }
    &.primary {
        width: 147px;
        color: #fff;
        background-color: #4c84ff;
        @include media-600 {
            width: 100%;
        }
    }
    &.reverse {
        width: 160px;
        color: #4c84ff;
        background-color: rgba(76, 132, 255, 0.1);
        &:hover {
            color: #fff;
            background-color: #4c84ff;
            &:active {
                position: relative;
                &:before {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background-color: rgba(0, 0, 0, 0.1);
                    border-radius: 20px;
                }
            }
        }
    }
    &.inline {
        display: inline-block;
    }
    &.block {
        display: block;
    }
}
</style>
